"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingBanner = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _api = require("../../api");
var _sponsorContext = require("../../context/sponsorContext");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FloatingBanner = () => {
  const {
    handleCloseSponsorBanner,
    sponsorBannerOpen,
    handleClickSponsorBanner
  } = (0, _sponsorContext.useSponsor)();
  const {
    translations,
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    data,
    isLoading
  } = (0, _api.usePersonalBeautyStoreData)(sponsorBannerOpen);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const handleClearClick = (0, _react.useCallback)(e => {
    e.stopPropagation();
    handleCloseSponsorBanner();
  }, [handleCloseSponsorBanner]);
  const profileData = (0, _utils.extractProfileData)(data?.beautyStore?.profile);
  const isInternationalSponsor = profileData === false;
  const sponsorMessage = isInternationalSponsor ? translations.internationalSponsorMessage : formatMessage('sponsorMessage', profileData);
  const sponsorGreetings = isInternationalSponsor ? translations.internationalSponsorGreetings : translations.sponsorGreetings;
  if (!sponsorBannerOpen || isLoading) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FloatingBannerRoot, {
    "data-testid": getTestId(_constants.FLOATING_BANNER),
    "aria-label": translations.viewWelcomeGiftInformation,
    onClick: handleClickSponsorBanner,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BannerIcon, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.GiftFilled, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InnerText, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SponsorText, {
        "data-testid": getTestId(_constants.FLOATING_BANNER_GREETING),
        variant: "overline",
        children: sponsorGreetings
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SponsorText, {
        "data-testid": getTestId(_constants.FLOATING_BANNER_MESSAGE),
        children: sponsorMessage
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ClearIcon, {
      "data-testid": getTestId(_constants.FLOATING_BANNER_CLOSE_ICON),
      "aria-label": translations.close,
      onClick: handleClearClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
    })]
  });
};
exports.FloatingBanner = FloatingBanner;
